/**
 * This function determines if the code is running in a client-side (browser) environment.
 * It returns true if the window object is defined (running client-side) and returns false
 * if the window object is undefined (running in a non-browser/server-side environment).
 *
 * NOTE: Using isBrowser() for client-side rendering logic may cause hydration mismatch
 * warnings. You must check that the app has finished hydrating using the useSSR() hook.
 *
 * @returns {boolean} true if window is defined, false otherwise
 */
export const isBrowser = () => {
    return typeof window !== "undefined";
};

/**
 * This function determines if the code is running in a server-side environment. It returns
 * true if the window object is undefined (running server-side) and returns false if the
 * window object is defined (meaning it's running in a client-side/browser environment).
 *
 * @returns {boolean} true if window is undefined, false otherwise
 */
export const isServer = () => {
    return typeof window === "undefined";
};
